// plugins/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyCnW2U_KD_v0O-bjWvqwhO4qwOI9_K1hSE",
  authDomain: "nava-tel.firebaseapp.com",
  projectId: "nava-tel",
  storageBucket: "nava-tel.appspot.com",
  messagingSenderId: "586769003980",
  appId: "1:586769003980:web:480223c89a8c63f60fd969",
  measurementId: "G-ST1YBBWN9G",
};

const firebaseApp = initializeApp(firebaseConfig);
const firestore = getFirestore(firebaseApp);
const auth = getAuth(firebaseApp);

export { firebaseApp, firestore, auth };
